export default __webpack_public_path__ + "static/media/warning.a7c6f251.svg";